import moment from 'moment';

// "Posted today" for anything posted on the current day, otherwise
// "Posted 3 days ago". Avoids "Posted 5 hours ago" making a fresh job look old.
export default function postedAgo(date) {
  const posted = moment(date);

  if (posted.isSame(moment(), 'day')) {
    return 'Posted today';
  }

  return `Posted ${posted.fromNow()}`;
}
